export default __webpack_public_path__ + "static/media/81.03ae305d.jpeg";